import Vue from 'vue'
import Vuex from 'vuex'
import { toastModule } from './toastModule.js'
import { modalModule } from './modalModule.js'
import _ from 'lodash'

const SESSION_TIMEOUT_DURATION = 60 // 60 by default

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uiBlocked: false,
    uiBlockedRemotely: false,
    uiBlockedByReconnect: false,
    timeoutAlertVisible: false,
    currentCp: null, // preserved during startup
    deviceId: null, // preserved during startup,
    slideUp: 0,
    userToken: '',
    fingerprint: '',
    authorizationQr: '',
    deliveryRequestId: '',
    logEntries: [],
    clientUser: null,
    serviceProviderSlug: ''
  },
  mutations: {
    blockUI(state, payload) {
      state.uiBlocked = payload
    },
    blockUIRemotely(state, payload) {
      state.uiBlockedRemotely = payload
    },
    blockUIReconnect(state, payload) {
      state.uiBlockedByReconnect = payload
    },
    slideUp(state, payload) {
      state.slideUp = payload
    },
    startSessionTimer() {
      clearTimeout(window.timerTimeout)
      if (!Vue.prototype.$dev) {
        window.timerTimeout = setTimeout(() => {
          this.commit('setTimeoutAlertVisibility', true)
        }, 1000 * SESSION_TIMEOUT_DURATION)
      }
    },
    stopSessionTimer(state) {
      clearTimeout(window.timerTimeout)
      state.timeoutAlertVisible = false
    },
    resetSessionTimer(state) {
      state.timeoutAlertVisible = false
      this.commit('startSessionTimer')
    },
    setTimeoutAlertVisibility(state, payload) {
      state.timeoutAlertVisible = payload
    },
    setDeviceId(state, payload) {
      state.deviceId = payload
    },
    setCurrentCp(state, payload) {
      let awakenMyMasters = (masters, slaves) => {
        return masters.map((master) => {
          let belongingSlaves = slaves.filter((slave) => slave.masterId == master.id)
          console.log('belongingSlaves:', belongingSlaves)
          belongingSlaves.forEach((slave) => {
            slave.boxes.forEach((box) => {
              master.boxes.push(box)
            })
          })

          return master
        })
      }

      let parseCpus = (cpus) => {
        // additional step for master-slave boxes, we move them to one cpu
        if (_.map(cpus, 'kind').indexOf('slave') != -1) {
          let masters = cpus.filter((cpu) => cpu.kind == 'master')
          let slaves = cpus.filter((cpu) => cpu.kind == 'slave')

          let myMasters = awakenMyMasters(masters, slaves)
          return myMasters
        } else {
          return cpus
        }
      }

      let sortCpus = (a, b) => {
        return a.position - b.position
      }

      let units = [...parseCpus(payload.units).sort(sortCpus)]
      let cp = { ...payload, units }

      state.currentCp = cp
      window.localStorage.setItem('cp', JSON.stringify(cp))
    },
    setUserToken(state, payload) {
      state.userToken = payload
      payload.length
        ? window.localStorage.setItem('user_token', payload)
        : window.localStorage.removeItem('user_token')
    },
    setFingerprint(state, payload) {
      // INFO: QR2
      state.fingerprint = payload
      window.localStorage.setItem('fingerprint', payload)
    },
    setAuthorizationQr(state, payload) {
      state.authorizationQr = payload
    },
    setDeliveryRequestId(state, payload) {
      state.deliveryRequestId = payload
      window.localStorage.setItem('delivery_request_id', payload)
    },

    killSession(state) {
      state.modal.modals = []
      state.uiBlocked = false
    },
    removeCp(state) {
      state.currentCp = null
      window.localStorage.removeItem('cp')
    },
    removeDeliveryRequestId(state) {
      state.deliveryRequestId = ''
      window.localStorage.removeItem('delivery_request_id')
    },
    addLogEntry(state, payload) {
      let entries =
        JSON.parse(window.localStorage.getItem('log_entries')) || state.logEntries

      state.logEntries = [...entries, payload]
      state.logEntries = [payload]

      try {
        window.localStorage.setItem('log_entries', JSON.stringify(state.logEntries))
      } catch {
        window.localStorage.setItem('log_entries', '')
      }
    },
    setClientUser(state, payload) {
      state.clientUser = payload
      window.localStorage.setItem('client_user', JSON.stringify(payload))
    },
    setServiceProviderSlug(state, payload) {
      state.serviceProviderSlug = payload
    }
  },
  actions: {},
  modules: {
    toast: toastModule,
    modal: modalModule
  },
  getters: {
    getBlockerStatus: (state) => {
      return state.uiBlocked
    },
    getRemoteBlockerStatus: (state) => {
      return state.uiBlockedRemotely
    },
    getReconnectBlockerStatus: (state) => {
      return state.uiBlockedByReconnect
    },
    getSlideUpStatus: (state) => {
      return state.slideUp
    },
    getSessionTimerStatus: (state) => {
      return state.timeoutAlertVisible
    },
    getDeviceId: (state) => {
      // INFO: we do not store device_id on remote devices. We use CP UUID instead
      // console.log('isRemoteClient', Vue.prototype.$isRemoteClient)
      // return state.deviceId || window.localStorage.getItem("device_id")

      // if (Vue.prototype.$isRemoteClient && state.currentCp && state.currentCp.id) {
      //   return state.currentCp.id
      // } else {
      //   return state.deviceId || window.localStorage.getItem("device_id")
      // }
      return state.deviceId || window.localStorage.getItem('device_id')
    },
    getCurrentCp: (state) => {
      return state.currentCp || JSON.parse(window.localStorage.getItem('cp'))
    },
    getUserToken: (state) => {
      return state.userToken
    },
    getFingerprint: (state) => {
      return state.fingerprint
    },
    getAuthorizationQr: (state) => {
      return state.authorizationQr || ''
    },
    getDrId: (state) => {
      return state.deliveryRequestId || window.localStorage.getItem('delivery_request_id')
    },
    getLogEntries(state) {
      return [
        ...state.logEntries,
        ...JSON.parse(window.localStorage.getItem('log_entries'))
      ].reverse()

      // JSON.parse(window.localStorage.getItem("log_entries")) || state.logEntries
    },
    getClientUser(state) {
      return state.clientUser || JSON.parse(window.localStorage.getItem('client_user'))
    },
    getServiceProviderSlug(state) {
      return state.serviceProviderSlug
    }
  }
})
